var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIconFive2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 9.5H33.25C31.9383 9.5 30.875 10.5633 30.875 11.875V21.375C30.875 22.6867 31.9383 23.75 33.25 23.75H42.75C44.0617 23.75 45.125 22.6867 45.125 21.375V11.875C45.125 10.5633 44.0617 9.5 42.75 9.5Z",
    fill: "#D1A97A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 49.875H14.25C12.9383 49.875 11.875 50.9383 11.875 52.25V61.75C11.875 63.0617 12.9383 64.125 14.25 64.125H23.75C25.0617 64.125 26.125 63.0617 26.125 61.75V52.25C26.125 50.9383 25.0617 49.875 23.75 49.875Z",
    fill: "#D1A97A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.75 49.875H52.25C50.9383 49.875 49.875 50.9383 49.875 52.25V61.75C49.875 63.0617 50.9383 64.125 52.25 64.125H61.75C63.0617 64.125 64.125 63.0617 64.125 61.75V52.25C64.125 50.9383 63.0617 49.875 61.75 49.875Z",
    fill: "#D1A97A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23.75V35.625",
    stroke: "#D1A97A",
    strokeWidth: 2.08219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 35.625V49.875",
    stroke: "#D1A97A",
    strokeWidth: 2.08219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 49.875V35.625",
    stroke: "#D1A97A",
    strokeWidth: 2.08219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 35.625H68.875",
    stroke: "#D1A97A",
    strokeWidth: 2.08219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIconFive2);
export default __webpack_public_path__ + "static/media/service-icon-five-2.13959ca887eb56b4db1c5b7bc2bc6c5f.svg";
export { ForwardRef as ReactComponent };